export const ScrollTopArrow = (props) => (
  <svg
    width="17"
    height="25"
    viewBox="0 0 17 25"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.25256 0.904158L7.25256 23.2374C7.25256 23.7413 7.65968 24.1484 8.1636 24.1484C8.66752 24.1484 9.07465 23.7413 9.07465 23.2374L9.07465 3.1049L14.6036 8.63381C14.9594 8.98968 15.5374 8.98968 15.8932 8.63381C16.2491 8.27793 16.2491 7.69998 15.8932 7.34411L8.80703 0.257885C8.5451 -0.00403943 8.15506 -0.0809094 7.81342 0.0614418C7.47462 0.203793 7.25256 0.536892 7.25256 0.904158Z"
      fill={props?.color}
    />
    <path
      d="M0.156447 7.99909C0.156447 8.23254 0.244706 8.466 0.424067 8.64252C0.779944 8.99839 1.35789 8.99839 1.71377 8.64252L8.80853 1.54775C9.16441 1.19187 9.16441 0.61393 8.80853 0.258053C8.45265 -0.0978241 7.87471 -0.097824 7.51883 0.258053L0.424067 7.35282C0.244706 7.53218 0.156447 7.76563 0.156447 7.99909Z"
      fill={props?.color}
    />
  </svg>
);
